import axios from 'axios';
import { agentSuggestionsAction } from './AgentSuggestionsSlice';

const getAgentSuggestionsListData = (lang = 'en') => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/recommended/prompts?lang=${lang}&platform=web`;
      const response = await axios.get(url, {});
      return response;
    };
    try {
      const result = await fetchData();
      const suggestionsListData = result.data;
      dispatch(agentSuggestionsAction.subscriptionListHandler({ suggestionsListData }));
    } catch (e) {}
  };
};

export default getAgentSuggestionsListData;